<template>

    <LoopItemPanel title="Categorie">

        <div class="shop::canvas-blocks-shop-overlappingCategories-Admin-CategoryPanel">

            <accordion-input :open="true">
                <template #label>
                    <div class="font-medium text-gray-600">Categorie selecteren</div>
                </template>
                <template #content>

                    <treeselect
                        ref="treeselect"
                        v-model="loopItem.category"
                        :options="treeOptions"
                        clearAllText="Verwijder allemaal"
                        clearValueText="Verwijder"
                        loadingText="Laden..."
                        noChildrenText="Geen categorieeën"
                        noOptionsText="Geen keuzes..."
                        noResultsText="Geen keuzes..."
                        placeholder="Kies categorie..."
                        retryText="Probeer opnieuw"
                        searchPromptText="Typ om te zoeken"
                        :closeOnSelect="true"
                        @input="save()"
                        :multiple="false"
                        search-nested
                    >

                        <template slot="option-label" slot-scope="{ node }">

                            <div
                                class="text-sm"
                                :class="{
                                'py-1': true,
                            }"
                            >
                                {{ node.raw.label }}
                            </div>

                        </template>

                        <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>

                    </treeselect>


                    <div class="py-6"></div>

                </template>
            </accordion-input>

        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";
import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import AccordionInput from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input';

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        Treeselect,
        AccordionInput,
    },

    data() {
        return {
            categories: null,
        };
    },

    async mounted()
    {
        await this.loadData();
    },

    methods: {

        async loadData() {
            // Load artists.
            this.categories = (await axios.get('/admin/modules/shop/categories/get-tree')).data;
        },

        mapItem(category, children) {
            // Abort due to no items? Otherwise Treeselect will show empty subtree.
            if (!children.length)
                return undefined;

            return _.map(children, category => {
                return {
                    id: category.id,
                    label: category.name.nl, // TODO Medium: support search & multi language.
                    children: this.mapItem( category, category.children ),
                };
            });
        },

    },

    computed: {

        treeOptions() {

            // Abort due to empty?
            if (this.categories === null)
                return [];

            // Map website pages.
            return _.map(this.categories, category => {
                return {
                    id: category.id,
                    label: category.name.nl, // TODO Medium: Add language support?
                    children: this.mapItem(category, category.children),
                };
            });
        },

    }

}

</script>

<style lang="scss" scoped>

.shop\:\:canvas-blocks-shop-overlappingCategories-Admin-CategoryPanel {

}

</style>
